export default __webpack_public_path__ + "static/media/not-found.dc4c2638.gif";